import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches contact people for one or more lead IDs.
 * @param {Array<string>} [leadIds=[]] - Array of companyId UUIDs
 * @returns {Promise<{data: Array<Object>, error: Error|null}>}
 */
export const fetchContactPeopleByLeadIds = async (leadIds = []) => {
	if (leadIds.length === 0) return { data: [], error: null };

	try {
		const result = await fetcher(`/api/v1/leads/companies/${leadIds[0]}/contacts`);

		// If multiple leadIds, fetch contacts for all companies
		if (leadIds.length > 1) {
			const allResults = await Promise.all(
				leadIds.map((id) => fetcher(`/api/v1/leads/companies/${id}/contacts`)),
			);
			const allContacts = allResults.flatMap((r) => r.contacts ?? []);
			return { data: allContacts, error: null };
		}

		return { data: result.contacts ?? [], error: null };
	} catch (error) {
		return { data: [], error };
	}
};

/**
 * Fetches all contact people of a prospect query.
 * @param {string} prospectQueryId - UUID of the prospect query
 * @returns {Promise<{data: Array<Object>, error: null}>}
 */
export const fetchContactPeopleByProspectQuery = async (prospectQueryId) => {
	if (!prospectQueryId) return { data: [], error: null };

	const result = await fetcher(`/api/v1/leads/queries/${prospectQueryId}/contacts`);
	return { data: result.contacts ?? [], error: null };
};

/**
 * Adds contact people to a contact list.
 * @param {Array<string>} contactPersonIds - Array of contact person UUIDs
 * @param {string} emailListId - UUID of the contact list
 * @returns {Promise<{error: Error|null}>}
 */
export const addContactPeopleToEmailList = async (contactPersonIds, emailListId) => {
	try {
		await fetcher(`/api/v1/contact-lists/${emailListId}/contacts`, {
			method: 'POST',
			body: { crmContactIds: contactPersonIds },
		});
		return { error: null };
	} catch (error) {
		return { error };
	}
};
